import * as React from "react";
import { SVGProps } from "react";

const OfflineRegistrationBackIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`min-icon`}
    fill={"currentcolor"}
    viewBox="0 0 256 256"
    {...props}
  >
    <path data-name="Rect\xE1ngulo 1602" fill="none" d="M0 0h256v256H0z" />
    <g fill="#2781b0">
      <path
        data-name="Trazado 7242"
        d="m20.695 32.211 11.313-11.318 203.3 203.4-11.313 11.318Z"
      />
      <path
        data-name="Trazado 7243"
        d="M19.371 106.631C6.694 118.186 0 133.962 0 152.26a61.725 61.725 0 0 0 20.253 46.312c12.578 11.424 29.547 17.714 47.778 17.714h114.108L55.275 89.429c-14.007 2.7-26.556 8.672-35.911 17.2Z"
      />
      <path
        data-name="Trazado 7244"
        d="M238.286 203.889C249.875 194.662 256 180.961 256 164.264c0-30.939-24.23-47.692-48.894-51.341-3.258-20.595-12.03-38.216-25.568-51.249a76.817 76.817 0 0 0-53.589-21.459 73.336 73.336 0 0 0-41.553 12.506l151.47 151.492c.128-.107.285-.206.42-.313Z"
      />
    </g>
  </svg>
);

export default OfflineRegistrationBackIcon;
